import { render, staticRenderFns } from "./BaseInfoModal.vue?vue&type=template&id=a1831268&scoped=true"
import script from "./BaseInfoModal.vue?vue&type=script&lang=js"
export * from "./BaseInfoModal.vue?vue&type=script&lang=js"
import style0 from "./BaseInfoModal.vue?vue&type=style&index=0&id=a1831268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1831268",
  null
  
)

export default component.exports